/// <reference path="../../_ext/editors/GridEditorBase.ts" />

namespace TabAurous.Administration {
    import fld = QualityInspectionTemplateDetailsRow.Fields;

    @Serenity.Decorators.registerClass()
    export class QualityInspectionTemplateDetailsEditor extends _Ext.GridEditorBase<QualityInspectionTemplateDetailsRow> {
        protected getColumnsKey() { return "Administration.QualityInspectionTemplateDetails"; }
        protected getDialogType() { return QualityInspectionTemplateDetailsDialog; }
        protected getLocalTextPrefix() { return QualityInspectionTemplateDetailsRow.localTextPrefix; }
        exchangerate: number;
        rateid: string;
        public CategoryId: number;
        typeid: number; 

        constructor(container: JQuery) {
            super(container); 
        } 

     
    }
}